import { Select } from 'antd';
import { useTyreCatalogueSelect } from '../hooks/use-tyre-catalogue-select';

interface CatalogueEntry {
  id: string;
  name: string;
}

interface TyreCatalogueSelectProps {
  id?: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  fetch: (q: string | undefined) => Promise<CatalogueEntry[]>;
  add: (name: string) => Promise<CatalogueEntry>;
  /** Whether the user may add a value that isn't there; without it the picker only picks. */
  canAdd: boolean;
  savedName?: string | null;
  /** What the values are, in the singular, for the placeholder and the empty message ("brand"). */
  noun: string;
}

/** Remote-search picker over a tyre catalogue, opening on its first page; typing a value that isn't there offers to add it. */
export function TyreCatalogueSelect({ id, value, onChange, fetch, add, canAdd, savedName, noun }: TyreCatalogueSelectProps) {
  const { selectProps, error } = useTyreCatalogueSelect({ fetch, add, canAdd, value, onChange, savedName });

  return (
    <div>
      <Select
        {...selectProps}
        id={id}
        value={value}
        placeholder={canAdd ? `Select, search or add a ${noun}` : `Select or search ${noun}s`}
        notFoundContent={selectProps.loading ? 'Searching…' : `No ${noun}s found`}
        status={error ? 'error' : undefined}
      />
      {error && (
        <p role="alert" className="text-danger mt-1 text-sm">
          {error}
        </p>
      )}
    </div>
  );
}
